import { render, staticRenderFns } from "./CompanyGig.vue?vue&type=template&id=b330fed8&scoped=true&"
import script from "./CompanyGig.vue?vue&type=script&lang=js&"
export * from "./CompanyGig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b330fed8",
  null
  
)

export default component.exports